import React, { useEffect, useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CartBox from '../DineIn/shoppingCart/CartBox';
import ShoppingCartDialog from './shoppingCart/ShoppingCartDialog';
import MenuWrapper from '../DineIn/menu/MenuWrapper';
import AddMealDialog from './AddMealDialogNew';
import AddSpecMealDialog from './AddSpecMealDialogNew';
import MenuDrawer from '../common/MenuDrawer';
import {updateDiscount} from '../../actions/dineIn';
import MenuIcon from '@material-ui/icons/Menu';
import { useFontSize } from '../../contexts/FontSizeContext';

import lng from '../../misc/lng';

const {chiLng} = lng;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
    },
    appBar: {
        backgroundColor: '#666666',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        // Prevent touch events from triggering scroll
        touchAction: 'none',
        userSelect: 'none',
    },
    toolbar: {
        minHeight: '65px',
        justifyContent: 'space-between',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    content: {
        flex: '1',
        paddingBottom: '75px',
        // Add top margin to account for AppBar height
        marginTop: '65px',
        // Ensure scroll events are contained
        overflow: 'hidden',
        position: 'relative',
    },
    footer: {
        // position: 'fixed',
        // bottom: '0',
        // left: '0',
        // height: '70px',
        // width: '100%',
        // backgroundColor: 'white',
        // boxShadow: '0px 0 5px rgba(0, 0, 0, 0.8)',
        // display: 'flex',
        // // flexDirection: 'column',
        // alignItems: 'center',
    },
    title: {
        color: 'white',
        fontWeight: '600',
        flex: 1,
        textAlign: 'center',
        // fontSize will be set dynamically
    },
    menuButton: {
        color: 'white',
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
    },
  }));


export default (props) => {
    const classes = useStyles();
    const { getFontSize } = useFontSize();
    const {
        productData
    } = useSelector((store) => store.productsReducer);
    const {
        tableInCharge: {
            orders,
        },
    } = useSelector((store) => store.dineInReducer);
    const dispatch = useDispatch();
    const [shoppingCartOpen, setShoppingCartOpen] = useState(false);
    const [menuDrawerOpen, setMenuDrawerOpen] = useState(false);

    // Dynamic font sizes
    const appTitleFontSize = getFontSize('appTitle');

    // Handle font size changes
    const handleFontSizeChange = (newSize) => {
        // No need to reload page - context will handle re-rendering
    };
    useEffect(
        () => {
            dispatch(updateDiscount(orders));
        }, [productData]
    );
    return(
        <div className={classes.root}>
            <ShoppingCartDialog
                open={shoppingCartOpen}
                handleClose={() => {setShoppingCartOpen(false)}}
            />
            <MenuDrawer
                open={menuDrawerOpen}
                onClose={() => setMenuDrawerOpen(false)}
                onFontSizeChange={handleFontSizeChange}
                tableName="外帶"
                tableId=""
            />
            <AddMealDialog />
            <AddSpecMealDialog />

            <AppBar 
                position="fixed" 
                className={classes.appBar}
                onTouchMove={(e) => e.stopPropagation()}
                onWheel={(e) => e.stopPropagation()}
            >
                <Toolbar className={classes.toolbar}>
                    {/* Menu Button */}
                    <IconButton
                        className={classes.menuButton}
                        onClick={() => setMenuDrawerOpen(true)}
                        aria-label="menu"
                    >
                        <MenuIcon />
                    </IconButton>

                    <Typography
                        variant='inherit'
                        className={classes.title}
                        style={{ fontSize: appTitleFontSize }}
                    >
                        ALL DAY
                    </Typography>

                    {/* Spacer for right side to center the title */}
                    <div style={{ width: 48 }} />
                </Toolbar>
            </AppBar>

            <div className={classes.content}>
                <MenuWrapper />
            </div>
            <div className={classes.footer} onClick={() => {setShoppingCartOpen(true)}}>
                <CartBox />
            </div>

        </div>
    );
};